import { useState } from 'react';

export const useModalState = <T>(cleanupDelay = 300) => {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState<T | null>(null);

  const open = (newData: T) => {
    setData(newData);
    setIsOpen(true);
  };

  const close = () => {
    setIsOpen(false);
    setTimeout(() => {
      setData(null);
    }, cleanupDelay);
  };

  return {
    isOpen,
    data,
    open,
    close,
  };
};
